
import TourNavButtons from './TourNavButtons';


export default class TourUI {
  constructor() {
    this.tourNavButtons = new TourNavButtons();
  }


}